var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plaid-link-wrapper"},[_vm._t("button",[_c('button',{staticClass:"plaid-link-button",on:{"click":_vm.handleOnClick}},[_vm._t("default")],2)],{"onClick":_vm.handleOnClick})],2)}
var staticRenderFns = []

export { render, staticRenderFns }